import {find, head} from 'lodash'

import {processStringContent, replaceSpecialChars} from 'utils/content'
import Answer from './Answer'
import Expression from './Expression'
import Graphing from './Graphing'
import Poll from './Poll'
import Spreadsheet from './Spreadsheet'
import AnswerChoice from "./AnswerChoice";
import InlinePollResponse from "./InlinePollResponse";


export default class ByQuestionCompiler {
    compile(rows, streams, challenge_cards, lesson) {
        const is_new = this.isNewDataModel(lesson);
        if (is_new) {
            rows.push(['Question', 'Student', 'Answer(s)']);
        } else {
            // Not supporting old data model any more
            return null;
        }
        
        challenge_cards.map((challenge_card) => {
            if (challenge_card.polls) {
                challenge_card.polls.filter((p) => p.type === 'block').map((poll) => {
                    streams.map((stream) => {
                        const vote = find(stream.votes, (v) => v.poll_id === poll.id);
                        if (!vote) {
                            return null;
                        }
                        const cells = [];
                        cells.push(poll.title);
                        cells.push(stream.user.fname + ' ' + head(stream.user.lname));
                        if (vote) {
                            new Poll().render(cells, vote);
                        }
                        rows.push(cells);
                    });
                });
            }

            if (challenge_card.questions) {
                challenge_card.questions.map((question) => {
                    const poll = find(challenge_card.polls, {question_id: question.id});
                    streams.map((stream) => {
                        this.compileNew(rows, stream, question, poll);
                    });
                    
                });
            }
        });

        return rows;
    }

    compileNew(rows, stream, question, poll) {
        const user = stream.user;
        const user_votes = stream.votes;
        const responses = stream.responses;

        const response = find(responses, {question_id: question.id});
        if (!response) {
            return null;
        }

        const question_text = processStringContent(
            replaceSpecialChars(question.title, {convert_katex: false}),
            {
                keep_html: false,
                convert_html: false,
                convert_math: false
            }
        ).substr(0, 500);
        const question_full_text = 'Q' + question.number + ': ' + question_text;

        let cells = [];
        cells.push(question_full_text);
        cells.push(user.fname + ' ' + head(user.lname));

        switch (true) {
            case question.answer_type.startsWith('answer.'):
                if (!response) {
                    break
                }
                switch (true) {
                    case question.answer_type === 'answer.graphing':
                        new Graphing().render(cells, response);
                        break;
                    case question.answer_type.startsWith('answer.expression'):
                        new Expression().render(cells, response);
                        break;
                    case question.answer_type.startsWith('answer.choice_'):
                        new AnswerChoice().render(cells, component.data.options, response);
                        break;
                    default:
                        new Answer().render(cells, response);
                }
                break;
            case question.answer_type === 'poll.inline':
                if (!poll) {
                    break
                }
                if (response) {
                    InlinePollResponse(cells, poll, response);
                }
                break;
            case question.answer_type === 'poll.block':
                // In case of Poll block, question_id is undefined
                if (!poll) {
                    break
                }
                const vote = find(user_votes, (v) => v.poll_id === poll.id);
                if (vote) {
                    new Poll().render(cells, vote);
                }
                break;
            case question.answer_type === 'spreadsheet':
                if (response) {
                    new Spreadsheet().render(cells, response);
                }
                break;
        }

        if (cells.length > 2) {
            rows.push(cells);
        }
    }

    isNewDataModel(lesson) {
        return lesson.challenge_version.data_version > 0;
    }
}
